import React from 'react';
import styled from 'styled-components';
//
import messages from 'constants/messages';
import { IThemeProps } from 'theme';

export interface IErrorInlineProps {
  error?: Error;
  text?: string;
}

const StyledErrorInline = styled.div(({ theme }: IThemeProps) => {
  const { sizes, colors } = theme.primary;
  return {
    fontSize: sizes.fonts.md,
    color: colors.error,
  };
});

const ErrorInline = ({ error, text }: IErrorInlineProps) => {
  let message = messages.errors.default;
  if (error?.message) {
    message = error.message;
  }
  if (text) {
    message = text;
  }
  return (
    <StyledErrorInline>
      <span>{message}</span>
    </StyledErrorInline>
  );
};

export default ErrorInline;
